// @flow
import React from 'react';

import ProductSelectionPage from '../../common/product-selection/ProductSelectionComponent';
import NewProductLayout from '../../common/new-product-layout/NewProductLayoutComponent';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';

type Props = {
  parentLocation: string | null,
  config: Object,
  location: {
    pathname: string,
  },
};

const FullUploadProductComponent = (props: Props) => (
  <NewProductLayout
    parentLocation={props.parentLocation}
    onBackCallback={() => AnalyticsClient.trackEvent(productEvents.backButtonNewProduct())}
    onCloseCallback={() => AnalyticsClient.trackEvent(productEvents.closeButtonNewProduct())}
  >
    <ProductSelectionPage config={props.config} creationCategory="upload" />
  </NewProductLayout>
);

FullUploadProductComponent.displayName = 'FullUploadProductComponent';

FullUploadProductComponent.defaultProps = {
  parentLocation: null,
};

export default FullUploadProductComponent;
